<template>
  <div>
    <c-q-separator class="q-pb-lg" :withBackButton="true" />

    <PageCaption
      pageCaptionTitle="Revisão"
      pageCaptionDescription="Revise o Cadastro e Envie para Aprovação"
    />
    
    <InstitutionalIdentificationSectionView 
      :institutionalData="institutionalData" 
      :showDownloadButtons="false"
    />

    <c-q-separator class="q-pb-md" />

    <!-- ✅ MOSTRAR IMAGENS -->
    <InstitutionalImagesSection />

    <InstitutionalAccordion
      v-if="institutionalReviewData"
      :accordionsData="institutionalReviewData.accordions"
      mode="view"
    />

    <c-q-separator class="q-pb-md" />

    <div class="row fit no-wrap items-top">
      <div class="q-pr-xl q-mr-xl">
        <!--<InstitutionalDevicesSection /> -->
      </div> 

      <div class="q-pl-xl q-ml-md">
        <InstitutionalRequestedAdjustmentsSection 
        v-if="showSectionViewAskAdjustment"
        />
      </div>
    </div>

    <c-q-separator class="q-pt-xl q-pb-md" />

  <!--  <div class="row fit no-wrap items-top">
      <div class="q-pr-xl q-mr-xl">
        <InstitutionalDevicesDistributionSection />
      </div>
    </div> -->

    <InstitutionalActionButtonsSection
      :propShowBtnBackEdit="true"
      :propShowBtnCancelCreateNewCampaign="true"
      :propShowBtnSaveFocusedInstitutional="true"
      :propShowBtnApproveFocusedCampaign="true"
      :propShowBtnResendFocusedInstitutionalToApprove="true"
      :propShowBtnSendFocusedInstitutionalToApprove="true"
    />

   <!-- <ModalRequestAdjustmentsInstitutional /> -->
    <ModalRequestAdjustmentsInstitucional/>
  </div>
</template>

<script setup lang="ts">
import PageCaption from '@/components/PageCaption.vue';
import InstitutionalIdentificationSectionView from '@/components/telasInstitucionais/institutionalFormats/InstitutionalIdentificationSectionView.vue';
import InstitutionalImagesSection from '@/components/telasInstitucionais/InstitutionalImagesSection.vue';
import InstitutionalDevicesSection from '@/components/telasInstitucionais/InstitutionalDevicesSection.vue';
//import InstitutionalDevicesDistributionSection from '@/components/telasInstitucionais/InstitutionalDevicesDistributionSection.vue';
import InstitutionalRequestedAdjustmentsSection from '@/components/telasInstitucionais/InstitutionalRequestedAdjustmentsSection.vue';
import InstitutionalActionButtonsSection from '@/components/telasInstitucionais/institutionalFormats/InstitutionalActionButtonsSection.vue';
import { onMounted, computed } from 'vue'
import { useRouter } from 'vue-router';
import { useInstitutionalStore } from '@/stores/institutionalStore';
import ModalRequestAdjustmentsInstitucional from '@/views/modals/ModalRequestAdjustmentsInstitucional.vue';
import { EnumRouteNames } from '@/enums/enums';
import InstitutionalAccordion from '@/components/telasInstitucionais/institutionalFormats/InstitutionalAccordion.vue';

// const institutionalData = computed(() => {
//   return institutionalStore.reviewData || institutionalStore.institutionalDetail || institutionalStore.institutionalDraft
// })
const institutionalData = computed(() => {
  return institutionalStore.reviewData || institutionalStore.institutionalDetail || institutionalStore.institutionalDraft
})


const institutionalStore = useInstitutionalStore();
const router = useRouter();

onMounted(async () => {
  const id = router.currentRoute.value.params.id

  if (!id && !institutionalStore.reviewData) {
    router.push({ name: EnumRouteNames.INSTITUTIONAL_SEARCH })
    return
  }

  if (id && !institutionalStore.reviewData && !institutionalStore.institutionalDetail) {
    await institutionalStore.fetchInstitutionalById(Number(id))

    const imagens = institutionalStore.institutionalDetail?.imagens
    if (imagens?.length) {
      institutionalStore.setImagensDraft(imagens)
    }
  }

  // ✅ PRESERVAR DADOS AO VOLTAR
  sessionStorage.setItem('from', 'review')
})

const showSectionViewAskAdjustment = computed(() => {
  return institutionalStore.institutionalDetail?.comentarioAjuste
})




/*onMounted(async () => {
  const id = router.currentRoute.value.params.id

  if (!id && !institutionalStore.reviewData) {
    router.push({ name: EnumRouteNames.INSTITUTIONAL_SEARCH })
    return
  }

  if (id && !institutionalStore.reviewData && !institutionalStore.institutionalDetail) {
    await institutionalStore.fetchInstitutionalById(Number(id))

    const imagens = institutionalStore.institutionalDetail?.imagens
    if (imagens?.length) {
      institutionalStore.setImagensDraft(imagens)
    }
  }
})*/


// const institutionalReviewData = computed(() => {
//   const detail = institutionalData.value
//   if (!detail) return null

//   const imagens = detail.imagens || []

//   const mapTempo = (posicao: number) => {
//     const img = imagens.find((i: any) => i.posicaoImagem === posicao)
//     return img?.duracaoImagem || 10
//   }

//   return {
//     id: detail.id,
//     accordions: {
//       telasIniciais: [
//         { id: 1, tela: 'Tela 1', posicao: 1, ordem: 1, tempo: mapTempo(1) },
//         { id: 2, tela: 'Tela 2', posicao: 2, ordem: 2, tempo: mapTempo(2) },
//         { id: 3, tela: 'Tela 3', posicao: 3, ordem: 3, tempo: mapTempo(3) },
//         { id: 4, tela: 'Tela 4', posicao: 4, ordem: 4, tempo: mapTempo(4) }
//       ],

//       telasAtm: [
//         { id: 8, botao: 'Sacar sem cartão', posicao: 8 },
//         { id: 9, botao: 'Recarga celular', posicao: 9 },
//         { id: 10, botao: 'Mais serviços', posicao: 10 },
//         { id: 11, botao: 'Depositar dinheiro', posicao: 11 }
//       ],

//       telasAguardeGeral: [
//         { id: 6, tela: 'Tela Geral', posicao: 6 }
//       ],

//       telasAguardeChip: [
//         { id: 7, tela: 'Tela Chip', posicao: 7 }
//       ],

//       telasAbertura: [
//         { id: 5, tela: 'Tela Abertura', posicao: 5 }
//       ],

//       imagens,
//       corTexto: detail.corTexto ?? null,
//       exibeTelaAbertura: detail.exibeTelaAbertura ?? false,
//       alterarTelaAbertura: (detail as any).alterarTelaAbertura ?? 'nao'
//     }
//   }
// })

const institutionalReviewData = computed(() => {
  const detail = institutionalData.value
  if (!detail) return null

  const imagens = detail.imagens || []

  // const telasCadastradas = Array.isArray(detail.telasCadastradas)
  //   ? detail.telasCadastradas.map((t: any) => t.tipoTela ?? t)
  //   : String(detail.telasCadastradas || '')
  //       .split(',')
  //       .map((t: string) => t.trim())
  //       .filter(Boolean)

  // const hasTela = (tipo: string) => telasCadastradas.includes(tipo)

  const mapTempo = (posicao: number) => {
    const img = imagens.find((i: any) => i.posicaoImagem === posicao)
    return img?.duracaoImagem || 10
  }
  const telasCadastradas = Array.isArray(detail.telasCadastradas)
  ? detail.telasCadastradas.map((t: any) => t.tipoTela ?? t)
  : String(detail.telasCadastradas || '')
      .split(',')
      .map((t: string) => t.trim())
      .filter(Boolean)

  const hasTela = (tipo: string) => telasCadastradas.includes(tipo)

  return {
    id: detail.id,
    accordions: {
      telasIniciais: [
        { id: 1, tela: 'Tela 1', posicao: 1, ordem: 1, tempo: mapTempo(1) },
        { id: 2, tela: 'Tela 2', posicao: 2, ordem: 2, tempo: mapTempo(2) },
        { id: 3, tela: 'Tela 3', posicao: 3, ordem: 3, tempo: mapTempo(3) },
        { id: 4, tela: 'Tela 4', posicao: 4, ordem: 4, tempo: mapTempo(4) }
      ],
      telasAtm: [
        { id: 8, botao: 'Sacar sem cartão', posicao: 8 },
        { id: 9, botao: 'Recarga celular', posicao: 9 },
        { id: 10, botao: 'Mais serviços', posicao: 10 },
        { id: 11, botao: 'Depositar dinheiro', posicao: 11 }
      ],
      telasAguardeGeral: [
        { id: 6, tela: 'Tela Geral', posicao: 6 }
      ],
      telasAguardeChip: [
        { id: 7, tela: 'Tela Chip', posicao: 7 }
      ],
      telasAbertura: [
        { id: 5, tela: 'Tela Abertura', posicao: 5 }
      ],
      imagens,
      corTexto: detail.corTexto ?? null,
      exibeTelaAbertura: detail.exibeTelaAbertura ?? false,
      alterarTelaInicial: hasTela('INICIAL') ? 'sim' : 'nao',
      alterarTelaAguarde: hasTela('AGUARDE') ? 'sim' : 'nao',
      alterarTelaAbertura: hasTela('ABERTURA') ? 'sim' : 'nao'
    }
  }
})

</script>

<style scoped>

</style>
